import { Step } from "./Step";
import { Merit } from "../merit/Merit";
import { MeritSubGroup } from "../merit/MeritSubGroup";
import { MeritGroupType } from "../../enum/MeritGroupType";
import { MultiLanguage } from "../../MultiLanguage";
import { BaseMeritsType } from '../../enum/BaseMeritsType';

export class MeritGroupStep extends Step {
    private _id: string;
    private _description: MultiLanguage;
    private _groupType: number;
    private _maxScore: number;
    private _merits: Merit[];
    private _meritChilds: Array<MeritSubGroup | Merit>;

    constructor(step: any) {
        super(step);
        this._id = step.id;
        this._name = step.groupType || step.groupType === MeritGroupType.enum.MANAGEMENT_EXPERIENCIE ? MeritGroupType.translations[step.groupType] : MeritGroupType.translations[step.groupName] ;
        this._description = new MultiLanguage(step.description);
        this._maxScore = step.maxScore;
        this._merits = step.merits.map( merit => new Merit(merit));
        this._meritChilds = step.meritChilds ? step.meritChilds.map(baseMerit => baseMerit.type === BaseMeritsType.enum.MERIT ? new Merit(baseMerit) : new MeritSubGroup(baseMerit)) : [];
    }

    public get id(): string {
        return this._id;
    }
    public get description(): MultiLanguage {
        return this._description;
    }
    public get maxScore(): number {
        return this._maxScore;
    }
    public get merits(): Merit[] {
        return this._merits;
    }
    public get meritChilds() {
        return this._meritChilds;
    }
    public set meritChilds(meritChilds: Array<MeritSubGroup | Merit> ) {
        this._meritChilds = meritChilds;
    }
    public get totalScore(): number {
        return this.totalGroupScore();
    }
    public get meritsInGroup(): Merit[] {
        return this._meritChilds.filter(meritChild => meritChild.type === BaseMeritsType.enum.MERIT).map(meritChild => meritChild as Merit);
    }
    public get meritSubGroupsInGroupWithMerits(): MeritSubGroup[] {
        return this._meritChilds.filter(meritChild => meritChild.type === BaseMeritsType.enum.MERITSUBGROUP && (meritChild as MeritSubGroup).merits.length > 0).map(meritChild => meritChild as MeritSubGroup);
    }
    public get allMerits(): Merit[] {
        const merits = [];
        this.meritsInGroup.forEach(merit => merits.push(merit));
        this.meritSubGroupsInGroupWithMerits.forEach(meritSubGroup => meritSubGroup.merits.forEach(merit => merits.push(merit)));
        return merits;
    }
    public totalGroupScore(): number {
        var totalGroupScore = 0;
        this._meritChilds.forEach(meritChild => {
            var totalSubGroupScore = 0;
            if (meritChild.type === BaseMeritsType.enum.MERIT) {
                totalGroupScore = totalGroupScore + meritChild.userTotalScore;
            }
            if (meritChild.type === BaseMeritsType.enum.MERITSUBGROUP) {
                (meritChild as MeritSubGroup).merits.forEach(merit => {
                    totalSubGroupScore = totalSubGroupScore + merit.userTotalScore;
                });
                if(totalSubGroupScore > meritChild.maxScore) {
                    totalSubGroupScore = meritChild.maxScore;
                }
            }
            totalGroupScore = totalGroupScore + totalSubGroupScore;
        });
        if ( this._maxScore && totalGroupScore > this._maxScore ){
            totalGroupScore = this._maxScore;
        }
        return Number(totalGroupScore.toFixed(6));
    }
    public toServer() {
        let meritToServe = [];
        this.meritChilds.forEach(children => {
            if (children.type === BaseMeritsType.enum.MERIT) {
                meritToServe.push(children.toServer());
            }
            if (children.type === BaseMeritsType.enum.MERITSUBGROUP) {
                (children as MeritSubGroup).merits.forEach(merit => {
                    merit.meritGroupId = this._id;
                    meritToServe.push(merit.toServer());
                });
            }
        });
        return {
            id: this._id,
            merits: meritToServe
        }
    }
}